module.exports = __webpack_public_path__ + "static/img/1-nei.07d78f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1-nei.png
// module id = xNFW
// module chunks = 1